import React from 'react';

import { CALLBACK_TYPE_OPTIONS } from '@vlabs/api-bindings/src/luna-client/tasks/constants';
import { PlusIcon } from '@vlabs/icons';
import { Control, Divider } from '@vlabs/uikit';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
//
import { v4 as uuidv4 } from 'uuid';

import { CallbackPolicyForm } from '@vlabs/monokit/entities/handlers/ui/forms/callback-policy-form/CallbackPolicyForm';
import { defaultHttpValues } from '@vlabs/monokit/entities/handlers/ui/forms/callback-policy-form/defaultValues';

import st from './StepCallbacksPolicy.module.sass';

function StepCallbacksPolicy(): React.JSX.Element {
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({ name: 'notification_policy.task_callbacks', keyName: 'id' });

  return (
    <React.Fragment>
      <h6>{t('monokit:entities.handlers.ui.steps.step callbacks policy.title')}</h6>
      {fields.map((field, i) => (
        <div
          className={st.CallbackPolicyItem}
          key={field.id}
        >
          <CallbackPolicyForm
            // @ts-expect-error lack of types
            callbackTypeOptions={CALLBACK_TYPE_OPTIONS.raw}
            fieldName={`notification_policy.task_callbacks.${i}`}
          />
          <Divider small />
          <Control.Button
            data-testid="stepCallbackPolicy.deleteCallbackButton"
            kind="negative"
            onClick={() => remove(i)}
            type="button"
            variant="outlined"
          >
            {t('monokit:entities.handlers.ui.steps.step callbacks policy.delete button')}
          </Control.Button>
        </div>
      ))}
      <Control.Button
        data-testid="addButton"
        icon={<PlusIcon />}
        onClick={() => append({
          ...defaultHttpValues,
          id: uuidv4(), // crypto.randomUUID(),
        })}
        type="button"
        variant="dimmed"
      >
        {t('monokit:entities.handlers.ui.steps.step callbacks policy.add button')}
      </Control.Button>
      <Divider small />
    </React.Fragment>
  );
}

StepCallbacksPolicy.fieldNames = [
  'notification_policy',
];

export { StepCallbacksPolicy };
